/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Time granularity for aggregating cost data.
*/
export enum CostGranularity {
  COST_GRANULARITY_HOURLY = 'HOURLY',
  COST_GRANULARITY_DAILY = 'DAILY',
  COST_GRANULARITY_MONTHLY = 'MONTHLY',
  COST_GRANULARITY_TOTAL = 'TOTAL'
}
